import React, { useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import { useAuth } from "../context/AuthContext";
import useApi from "../utils/useApi";
import { useLoading } from "../context/LoadingContext";
import Toaster, { ToastContainerComponent } from "../components/Toaster";

const PersonalSettings = () => {
  const { callApi } = useApi();
  const { setLoading } = useLoading();
  const { user } = useAuth();
  const navigate = useNavigate();
  //profile
  const userDetails = async (e) => {  
    const isClient = user?.user_role?.toLowerCase() === "client";
    const endpoint = isClient
      ? "/client/profile" //we will get logged in user details from this api
      : "/admin/profile";
    const response = await callApi({ endpoint });
    console.log("res...",response);
    
    if (response?.success && response.data) {
      setName(response.data.user_name || "");
      setEmail(response.data.user_email || "");
      setCompany(response.data.user_company || "");
    }
  }

  useEffect(() => {
    userDetails();
  }, []);
  

  const [name, setName] = useState(user.user_name || "");
  const [email, setEmail] = useState(user.user_email || "");
  const [company, setCompany] = useState(user.user_company || "");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword) {
      Toaster.error("Both old and new passwords are required.");
      return;
    }

    setLoading(true);
    try {
      const isClient = user?.user_role?.toLowerCase() === "client";
      //console.log("isClient" , isClient);
      const endpoint = isClient
        ? "/client/change-password"
        : "/admin/change-password";

      const response = await callApi({
        endpoint,
        method: "POST",
        data: {
          old_password: oldPassword,
          new_password: newPassword,
        },
      });

      if (response?.success) {
        Toaster.success("Password changed successfully!");
        setOldPassword("");
        setNewPassword("");
      } else {
        Toaster.error(response?.message || "Failed to change password.");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      Toaster.error("Error changing password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserInfo = async (e) => {
    e.preventDefault();
    try {
      if (!name || !email) {
        Toaster.error("Name and Email are required.");
        return;
      }
      setLoading(true);
      const isClient = user?.user_role?.toLowerCase() === "client";
      const endpoint = isClient
        ? "/client/profile-update"
        : "/admin/update-user";
  
      const response = await callApi({
        endpoint,
        method: "PUT",
        data: {
          user_name: name,
          user_email: email,
          user_company: company,
        },
      });
  
      if (response?.success) {
        Toaster.success("User information updated successfully!");
        await userDetails(); // ✅ fetch latest info from server and set in state
      } else {
        Toaster.error(response?.message || "Failed to update user info.");
      }
    } catch (error) {
      console.error("Error changing User Details:", error);
      Toaster.error("Error changing User Details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <MainLayout>
      <ToastContainerComponent />
      <div className="inner_full_right_part">
        <div className="row">
          <div className="col-md-12">
            <div className="global_cardbox">
              <div className="global_card_header">
                <div className="global_head_tag">
                  <span>
                    <i className="fa-solid fa-user"></i>
                  </span>{" "}
                  Personal Settings
                </div>
              </div>

              <form onSubmit={handleChangeUserInfo}>
                <div className="global_cardbox inner_global_card">
                  <div className="global_card_header">
                    <div className="global_head_tag">
                      <span>1</span> User Information
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Company:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={company}
                      onChange={(e) => setCompany(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>

              <form onSubmit={handleChangePassword}>
                <div className="global_cardbox inner_global_card">
                  <div className="global_card_header">
                    <div className="global_head_tag">
                      <span>2</span> Change Password
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Old Password:</label>
                    <input
                      type="password"
                      className="form-control"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>New Password:</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Change Password
                  </button>
                </div>
              </form>

              <div className="update_btn_holder">
                <button
                  className="btn btn-primary orange_btn"
                  onClick={() => navigate("/clients")}
                >
                  Back to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PersonalSettings;
